import { NIBBLES_TRIO_BUNDLE_ALLERGENS } from "../constants/defaults";
import type { TCatFormDataInput } from "../schemas/cat-form-data.schema";
import type { TSubscriptionData } from "../schemas/subscription-data.schema";

/**
 * At hydration time, if any cat has an allergy to a trio bundle ingredient,
 * force nibblesUpsell.added to false so stale opt-ins don't leak through to checkout.
 */
export function clearNibblesForIneligibleCats<
  T extends {
    cats: Record<string, Pick<TCatFormDataInput, "diet">>;
    subscription: Pick<TSubscriptionData, "nibblesUpsell">;
  },
>(data: T): T {
  const upsell = data.subscription.nibblesUpsell;
  if (!upsell?.added) { return data; }

  const hasBlockingAllergy = Object.values(data.cats).some((cat) =>
    cat.diet?.foodAllergies?.allergens?.some((allergen) => NIBBLES_TRIO_BUNDLE_ALLERGENS.includes(allergen)),
  );

  if (hasBlockingAllergy) {
    data.subscription.nibblesUpsell = { ...upsell, added: false, quantity: 0 };
  }

  return data;
}
